export function getBooleanLabel(value: boolean): string {
  return value ? 'Tak' : 'Nie';
}
